import { render, staticRenderFns } from "./CustomerChat.vue?vue&type=template&id=1976951e&scoped=true&"
import script from "./CustomerChat.vue?vue&type=script&lang=js&"
export * from "./CustomerChat.vue?vue&type=script&lang=js&"
import style0 from "./CustomerChat.vue?vue&type=style&index=0&id=1976951e&prod&lang=css&"
import style1 from "./CustomerChat.vue?vue&type=style&index=1&id=1976951e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1976951e",
  null
  
)

export default component.exports